import styles from './CollapsibleNavSection.module.scss'

export default function NavSectionHeaderAction({
  Icon,
  label,
  onClick,
  buttonRef,
  ariaHaspopup,
  ariaExpanded,
}) {
  return (
    <button
      ref={buttonRef}
      type="button"
      className={styles.headerAction}
      aria-label={label}
      aria-haspopup={ariaHaspopup}
      aria-expanded={ariaExpanded}
      onClick={(e) => {
        e.stopPropagation()
        onClick?.(e)
      }}
    >
      <Icon aria-hidden />
    </button>
  )
}
